module.exports = __webpack_public_path__ + "img/headers_open_orders.04e052c0.jpg";